export const validateEmail = (email) =>
  /^[^@\s]+@[^@\s]+$/.test(String(email).toLowerCase());
